import gql from 'graphql-tag';

export const UPDATE_ESTIMATED_CLOSE_DATE = gql`
  mutation UpdateVOEstimatedCloseDate($input: UpdateVOEstimatedCloseDateInput!) {
    result: updateVOEstimatedCloseDate(input: $input) {
      error
      success
      entity {
        voId
      }
    }
  }
`;
